<div class="row justify-content-center">
  <div [ngClass]="{'col-12': this.isInPopup, 'col-xl-4 col-lg-5 col-md-6 col-sm-8': !this.isInPopup}">
    <h1 class="h3 mb-3 font-weight-normal" [ngClass]="{'text-center': this.isInPopup}">
      <span *ngIf="this.isInPopup">Video premium</span>
    </h1>
    <div class="form-group">
      <p>Debe acceder a un plan para poder ver este video.</p>
    </div>
    <div class="text-center">
      <button class="use-app-colors btn btn-lg btn-primary btn-block mt-3" type="button" (click)="this.buttonClickHandler()">
        <span *ngIf="!this.processing">
          {{!this.buttonWasClicked ? 'Ver planes': 'Ya obtuve un plan'}}
        </span>
        <div *ngIf="this.processing" class="spinner-border"></div>
      </button>
    </div>
    <div *ngIf="this.formData.error" [innerHTML]="this.formData.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
    <div *ngIf="this.formData.message" [innerHTML]="this.formData.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  </div>
</div>
